import BASEURLPROJETOS from '../api/projetos'
import { IndicadorPayload, AtualizarIndicadorPayload, ListarBancoIndicadorsQuery } from "../../interfaces/bancoIndicador"

export function listarBancoIndicador(queryParams: ListarBancoIndicadorsQuery) {
    return BASEURLPROJETOS.get(`/indicadores?titulo=${queryParams.titulo}&situacao=${queryParams.situacao}&grupo=${queryParams.grupo}`)
}

export function cadastrarIndicador(payload: IndicadorPayload) {
    return BASEURLPROJETOS.post(`/indicadores`, payload)
}

export function atualizarIndicador(idIndicador: string, idTarefaCript: string, payload: AtualizarIndicadorPayload) {
    return BASEURLPROJETOS.patch(`/indicadores/${idIndicador}/${idTarefaCript}`, payload)
}